import React from "react";

function withProps<T, K extends keyof T>(Component: React.ComponentType<T>, extraProps: Pick<T, K>) {
    return (props: any) => <Component {...props} {...extraProps} />;
}


export default withProps;
